import { TimelineMax, TweenMax } from 'gsap/TweenMax';
import selectors from '@/scripts/animation/animation-selectors';

function getAssets(section, title) {
  return {
    letters: Array.from(section.querySelectorAll(`${title} ${selectors.letter}`)),
    line: section.querySelector(`${title} ${selectors.line}`),
  };
}

export default {
  trigger: selectors.titleWithLine,
  set() {
    const { letters, line } = getAssets(this.section, selectors.titleWithLine);
    return TweenMax.set([letters, line], { autoAlpha: 0 });
  },

  animate() {
    const { letters, line } = getAssets(this.section, selectors.titleWithLine);
    const tl = new TimelineMax();
    return tl
      .fromTo(
        line, selectors.duration,
        { scaleX: 0, autoAlpha: 1, x: -20 },
        { scaleX: 1, x: 0 },
        selectors.delay.stage_1,
      )
      .staggerFromTo(
        letters, selectors.duration,
        { scaleX: 0, x: -20, autoAlpha: 1 },
        {
          autoAlpha: 1,
          scaleX: 1,
          x: 0,
          clearProps: 'all',
        }, selectors.delay.staggerLetters, selectors.delay.stage_3,
      );
  },
};



// WEBPACK FOOTER //
// ./scripts/animation/elements/title-with-line.js